import styled from "styled-components";

import colors from "core/colors";
import { rapidEasing } from "core/animation";
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";

export const GroupContainer = styled.div`
    display: inline-flex;
    border-radius: 0.25rem;
`;

export const Button = styled.button`
    cursor: pointer;
    outline: none;
    background-color: ${({ isActive }) =>
        isActive ? colors.midnight : "transparent"};
    color: ${({ isActive }) => (isActive ? colors.mist : colors.pebble)};
    min-width: 2.5rem;
    margin: 0;
    padding: 0.0625rem 1.375rem;
    font-size: 0.8125rem;
    line-height: 1.75;
    border: 1px solid
        ${({ isActive }) =>
            isActive ? "rgba(0, 0, 0, 0.23)" : colors.concrete};
    border-radius: 0.25rem;
    transition: background-color ${rapidEasing}, box-shadow ${rapidEasing},
        border ${rapidEasing};
    ${({ groupLength }) =>
        groupLength > 1 &&
        `
        :first-child{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right-color: transparent;
        }
        :not(:first-child):not(:last-child){
            border-radius: 0;
            border-right-color: transparent;
        }
        :last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    `} hover {
        background-color: ${({ isActive }) =>
            isActive ? colors.midnight : colors.concrete};
        color: ${({ isActive }) => (isActive ? colors.snow : colors.ink)};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding: ${convertPxToRem({ px: 1 })} ${convertPxToRem({ px: 16 })};
    }
`;

export const Label = styled.span`
    width: 100%;
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
`;
